import DatePicker from './DatePickerContainer'

export default DatePicker
